__turbopack_context__.v({
  "actions": "reports-visual-module__RBZmkq__actions",
  "actionsOn": "reports-visual-module__RBZmkq__actionsOn",
  "activity": "reports-visual-module__RBZmkq__activity",
  "chip": "reports-visual-module__RBZmkq__chip",
  "chipVisible": "reports-visual-module__RBZmkq__chipVisible",
  "clientName": "reports-visual-module__RBZmkq__clientName",
  "date": "reports-visual-module__RBZmkq__date",
  "filterBar": "reports-visual-module__RBZmkq__filterBar",
  "filterIcon": "reports-visual-module__RBZmkq__filterIcon",
  "filterIconActive": "reports-visual-module__RBZmkq__filterIconActive",
  "filterRow": "reports-visual-module__RBZmkq__filterRow",
  "head": "reports-visual-module__RBZmkq__head",
  "hours": "reports-visual-module__RBZmkq__hours",
  "hoursUnit": "reports-visual-module__RBZmkq__hoursUnit",
  "menu": "reports-visual-module__RBZmkq__menu",
  "menuHint": "reports-visual-module__RBZmkq__menuHint",
  "menuOn": "reports-visual-module__RBZmkq__menuOn",
  "menuRow": "reports-visual-module__RBZmkq__menuRow",
  "menuRowActive": "reports-visual-module__RBZmkq__menuRowActive",
  "name": "reports-visual-module__RBZmkq__name",
  "pill": "reports-visual-module__RBZmkq__pill",
  "pillDone": "reports-visual-module__RBZmkq__pillDone",
  "pillNone": "reports-visual-module__RBZmkq__pillNone",
  "pillOpen": "reports-visual-module__RBZmkq__pillOpen",
  "price": "reports-visual-module__RBZmkq__price",
  "root": "reports-visual-module__RBZmkq__root",
  "row": "reports-visual-module__RBZmkq__row",
  "rowOut": "reports-visual-module__RBZmkq__rowOut",
  "rows": "reports-visual-module__RBZmkq__rows",
  "toast": "reports-visual-module__RBZmkq__toast",
  "toastIcon": "reports-visual-module__RBZmkq__toastIcon",
  "toastOn": "reports-visual-module__RBZmkq__toastOn",
  "total": "reports-visual-module__RBZmkq__total",
  "totalOn": "reports-visual-module__RBZmkq__totalOn",
  "totalWide": "reports-visual-module__RBZmkq__totalWide",
  "totals": "reports-visual-module__RBZmkq__totals",
});
